/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { Payload } from './Payload';
import {
    PayloadFromJSON,
    PayloadFromJSONTyped,
    PayloadToJSON,
    PayloadToJSONTyped,
} from './Payload';

/**
 * 
 * @export
 * @interface DeviceEventSummary
 */
export interface DeviceEventSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    eventTimestamp: Date;
    /**
     * 
     */
    eventType: string;
    /**
     * 
     */
    runId: string | null;
    /**
     * 
     */
    payload: Payload;
}

/**
 * Check if a given object implements the DeviceEventSummary interface.
 */
export function instanceOfDeviceEventSummary(value: object): value is DeviceEventSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('eventTimestamp' in (value as Record<string, any>)) && !('event_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['eventTimestamp'] === undefined && (value as Record<string, any>)['event_timestamp'] === undefined)) return false;
    if ((!('eventType' in (value as Record<string, any>)) && !('event_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['eventType'] === undefined && (value as Record<string, any>)['event_type'] === undefined)) return false;
    if ((!('runId' in (value as Record<string, any>)) && !('run_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['runId'] === undefined && (value as Record<string, any>)['run_id'] === undefined)) return false;
    if (!('payload' in value) || value['payload'] === undefined) return false;
    return true;
}

export function DeviceEventSummaryFromJSON(json: any): DeviceEventSummary {
    return DeviceEventSummaryFromJSONTyped(json, false);
}

export function DeviceEventSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceEventSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'eventTimestamp': (json['event_timestamp'] == null ? json['event_timestamp'] : parseDateTime(json['event_timestamp'])),
        'eventType': json['event_type'],
        'runId': json['run_id'],
        'payload': PayloadFromJSON(json['payload']),
    };
}

export function DeviceEventSummaryToJSON(json: any): DeviceEventSummary {
    return DeviceEventSummaryToJSONTyped(json, false);
}

export function DeviceEventSummaryToJSONTyped(value?: DeviceEventSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'event_timestamp': value['eventTimestamp'] == null ? value['eventTimestamp'] : serializeDateTime(value['eventTimestamp']),
        'event_type': value['eventType'],
        'run_id': value['runId'],
        'payload': PayloadToJSON(value['payload']),
    };
}

